module.exports = __webpack_public_path__ + "img/tiktok.c95e0b0f.svg";